__turbopack_context__.v({
  "container": "styles-module__XtNjKq__container",
  "productBreadcrumbs": "styles-module__XtNjKq__productBreadcrumbs",
  "productBreadcrumbsWithSearchbar": "styles-module__XtNjKq__productBreadcrumbsWithSearchbar",
  "skeleton": "styles-module__XtNjKq__skeleton",
});
